import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private readonly stackKey = 'navigation_stack';

  constructor(private router: Router) {
    this.initStack();

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      const stack = this.getStack();
      const currentUrl = event.urlAfterRedirects;

      if (stack.length === 0 || stack[stack.length - 1] !== currentUrl) {
        //only for loggedin pages
        if (currentUrl.startsWith('/p/')) {
          stack.push(currentUrl);
          sessionStorage.setItem(this.stackKey, JSON.stringify(stack));
        }
      }
    });
  }

  goBack(): void {
    const stack = this.getStack();

    if (stack.length > 1) {
      stack.pop();
      const previousUrl = stack[stack.length - 1];
      sessionStorage.setItem(this.stackKey, JSON.stringify(stack));
      this.router.navigateByUrl(previousUrl);
    }
  }

  clearStack(): void {
    sessionStorage.removeItem(this.stackKey);
  }

  private initStack(): void {
    if (!sessionStorage.getItem(this.stackKey)) {
      sessionStorage.setItem(this.stackKey, JSON.stringify([]));
    }
  }

  private getStack(): string[] {
    return JSON.parse(sessionStorage.getItem(this.stackKey) || '[]');
  }

  public hasHistory(): boolean {
    return this.getStack().length > 1;
  }
}
